import AppButton from "./AppButton.vue";

export default {
  extends: AppButton
};
